import Joi from 'joi';
import { getNricFinJoiObject } from '../../utils/JoiUtils';
import { IdTypeType } from '../../models';

export interface ForgotUserNameFormData {
  IdType: IdTypeType;
  NricFinPassportNo: string;
  dateOfBirth: string;
}

const schemaForgotUsername = Joi.object<ForgotUserNameFormData>({
  IdType: Joi.string().required().messages({
    'any.required': 'Please select Id Type.',
    'string.base': 'Please select Id Type.',
  }),
  NricFinPassportNo: getNricFinJoiObject(),
  dateOfBirth: Joi.string().required().messages({
    'any.required': 'Please select Date of Birth.',
    'string.empty': 'Please select Date of Birth.',
  }),
});

export default schemaForgotUsername;
